import React from 'react';
import { ContactForm } from './ContactForm';
import { WaveBackground } from './WaveBackground';
export function FinalCTASection() {
  return <section id="contact-form" className="relative py-24 bg-[#0A1628] overflow-x-hidden" data-id="element-48">
      <WaveBackground data-id="element-49" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-50">
        <div className="flex flex-col items-center justify-center gap-12 max-w-4xl mx-auto" data-id="element-51">
          <div className="w-full text-center" data-id="element-52">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 font-playfair leading-tight" data-id="element-53">
              Ready to Attract More Buyers and{' '}
              <span className="text-[#D4AF37]" data-id="element-54">Increase Boat Sales?</span>
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-55">
              Your competitors are investing in digital. The question is: are
              those buyers finding you… or finding them?
            </p>
          </div>

          <div className="w-full max-w-2xl mx-auto" data-id="element-56">
            <ContactForm title="Get Started Today" subtitle="Fill out the form below to schedule your free strategy call." data-id="element-57" />
          </div>
        </div>
      </div>
    </section>;
}